<docs>
  Backend requires value to be positive integer.
</docs>

<template>
  <div class="metafield-edit-integer">
    <BaseInput
      :data-vv-as="field.type"
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      type="number"
      step="1"
      :hint="hint"
      @input="onInput"
      :validate="validator()"

      :prefix="subFormData.prefix"
      :suffix="subFormData.suffix"
      :minVal="+subFormData.min"
      :maxVal="+subFormData.max || Infinity"
      ></BaseInput>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  inject: ['$validator'],
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    subFormData: Object,
    value: [Number, String],
    hint: String
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? 0 : val)
    },
    validator () {
      return `integer|min_value:${+this.subFormData.min}|max_value:${+this.subFormData.max || Infinity}`
    }
  },
  created () {
    if (this.value === null) {
      this.$emit('input', 0)
    }
  }
}
</script>

<style lang="scss">
  .metafield-edit-integer {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditInteger.vue